let utils = {
    getUrlParam(name) {
        var result = ''
        var searchArr = decodeURIComponent(window.location.search)
            .slice(1)
            .split('&')
        searchArr.map(function (item) {
            var arr = item.split('=')
            if (arr[0] === name) {
                result = decodeURIComponent(arr[1])
            }
        })
        return result
    },
    /**
   * param 将要转为URL参数字符串的对象
   * key URL参数字符串的前缀
   * encode true/false 是否进行URL编码,默认为true
   * return URL参数字符串
   */
    urlEncode(param, key, encode) {
        return urlEncode(param, key, encode).replace(/^&/, '')
    }
}

function urlEncode(param, key, encode) {
    if (param == null) return ''
    var paramStr = ''
    var t = typeof param
    if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + (encode == null || encode ? encodeURIComponent(param) : param)
    } else {
        for (var i in param) {
            var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
            paramStr += urlEncode(param[i], k, encode)
        }
    }
    return paramStr
}
function dateValid(row, column) {
    const date = row[column.property];
    if (!moment(date).isValid()) {
      return '';
    }
    return moment(date).format('YYYY-MM-DD');
};
export default { ...utils }



// WEBPACK FOOTER //
// ./src/assets/js/utils.js